import { bus, axios, i18n, apiURL } from '../main'
import Vue from 'vue'

export default {
    state: { // state des Moduls wird direkt auf die Variable state.modulX gemappt
        dokumente:
        {
            /* '2018_de':[
                   {
                       title: 'Prüfbericht',
                       items: [{
                           title: 'Suisslab AG Zollikofen - Kuh',
                           year: 2017,
                           month: 3,
                           date: Date(),
                           viewed: false,
                           fileType: 'pdf',
                           url: '/components/pis/briefkasten.cfc?method=getFile&ID=123456&type=Analysen&art=1year=2017'
                       },{
                           title: 'Suisslab AG Zollikofen - Kuh2',
                           year: 2018,
                           month: 3,
                           date: Date(),
                           viewed: false,
                           fileType: 'pdf',
                           url: '/components/pis/briefkasten.cfc?method=getFile&ID=123456&type=Analysen&art=1year=2017'
                       }]
                   },
                   {
                       title: 'Test',
                       items: [{
                           title: 'Test - Kuh',
                           year: 2017,
                           month: 3,
                           date: Date(),
                           viewed: false,
                           fileType: 'pdf',
                           url: '/components/pis/briefkasten.cfc?method=getFile&ID=123456&type=Documents'
                       }
                       ]
                   }
               ] */
        },
        ungelesen: 0
    },
    /* reducer: state => ({
          analysen: state.analysenStore.analysen,
          analysenExpired: state.analysenStore.analysenExpired
          // errorMessage // this state is not included, no need to set to localStorage
      }), */
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')
        loadDokumente: async function ({ state }, { year, locale }) {
            try {
                var dokumente = await axios.get(apiURL + 'dokumente.cfc?method=getDokumente', { params: { jahr: year, locale: i18n.locale } })  //immer alle
                dokumente.data.forEach(element => {
                    let oldMonth = 0
                    element.items.forEach(itemX => {
                        if (itemX.month != oldMonth) {
                            itemX.monthChanged = true
                            oldMonth = itemX.month
                        }
                        else {
                            itemX.monthChanged = false
                        }
                    })
                });
                //state.dokumente[year.toString() + '_' + locale] = dokumente.data

                let docKey = year.toString() + '_' + locale
                Vue.set(state.dokumente, docKey, dokumente.data)
                
                bus.$emit('dokumenteLoaded', 'alles geladen')
            }
            catch (e) {
                bus.$emit('error', 'Dokumente konnten nicht geladen werden ..' + JSON.stringify(e.message))
            }
        },
        loadUngelesen: async function ({ commit }) {
            try {
                var ungelesen = await axios.get(apiURL + 'dokumente.cfc?method=getUngelesen')
                await commit('setUngelesen', ungelesen.data)
            }
            catch (e) {
                bus.$emit('error', 'Error loading not viewed docs ... ' + JSON.stringify(e.message))
            }
        },
    },
    mutations: {
        setGelesen: function (state, docX) {//
            state.dokumente[docX.yearlang][docX.groupIndex].items[docX.docIndex].viewed = true
        },
        setUngelesen: function (state, ungelesen) {
            state.ungelesen = ungelesen
        },
        decUngelesen: function (state) {
            if (state.ungelesen > 0)
                state.ungelesen--
        }
    }
}
